import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { getAxiosInstance } from "../../../api";


const axiosBaseQuery =
     () =>
          async ({ params, endpoint, method, body }) => {

               const api = await getAxiosInstance();
               const getParams = (key) => {

                    if (params?.[key]) {
                         return `${key}=${params[key]}&`;
                    } else {
                         return "";
                    }
               };

               try {
                    const response = await api[method](
                         `${endpoint}?${getParams("start")}${getParams(
                              "end"
                         )}${getParams("filter")}${getParams("sort_by")}is_active=${params?.is_active ? params["is_active"] : 0
                         }&sort_order=${params?.sort_order || "desc"
                         }&page_size=${params?.per_page || "10"}&${getParams("search")}${getParams("user_id")}page=${params?.page || 1
                         }`,
                         body
                    );

                    return { data: response.data };
               } catch (axiosError) {
                    let err = axiosError;

                    return {
                         data: err?.response?.data || err.message,
                    };
               }
          };

export const user = createApi({
     reducerPath: 'userApi',
     baseQuery: axiosBaseQuery(),
     tagTypes: ['user'],
     endpoints: (builder) => ({
          getUserListData: builder.query({
               query: (values) => ({
                    method: 'get',
                    params: values,
                    endpoint: `admin/users`
               }),
               providesTags: ['user']
          }),
          updateUserStatus: builder.mutation({
               query: (body) => ({
                    method: "post",
                    body,
                    endpoint: `/admin/users/change/status`,
               }),
               // invalidatesTags: ["user"]
          }),
          updateTableFieldsData: builder.mutation({
               query: (body) => ({
                    method: "post",
                    body,
                    endpoint: `/admin/user/fields/update`,
               }),
               invalidatesTags: ["user"],
          }),
          getUserOrderSummary: builder.query({
               query: (values) => ({
                 method: "get",
                 params: values,
                 endpoint: `/admin/users/order-history`,
               }),
               providesTags: ["UserOrderSummary"],
          }),
          getUserViewData: builder.query({
               query: (values) => ({
                 method: "get",
                 params: values,
                 endpoint: `/admin/users/user-view`,
               }),
               providesTags: ["UserView"],
          }),
     })
})

export const { useGetUserListDataQuery, useUpdateUserStatusMutation,
     useUpdateTableFieldsDataMutation,useGetUserOrderSummaryQuery,useGetUserViewDataQuery} = user;